(() => {
  const initialisePolicy = (root) => {
    if (!root || root.dataset.policyInitialised === 'true') return;
    root.dataset.policyInitialised = 'true';

    const content = root.querySelector('[data-policy-content]');
    const body = root.querySelector('.phq-policy__body');
    const primaryHeadings = content ? Array.from(content.querySelectorAll('h2')) : [];
    const headings = primaryHeadings.length
      ? primaryHeadings
      : (content ? Array.from(content.querySelectorAll('h3')) : []);
    const desktopNav = root.querySelector('[data-policy-toc]');
    const mobileNav = root.querySelector('[data-policy-toc-mobile]');
    const aside = root.querySelector('[data-policy-aside]');
    const mobileToc = root.querySelector('[data-policy-mobile-toc]');

    if (content) {
      Array.from(content.querySelectorAll('p')).forEach((paragraph) => {
        if (!paragraph.textContent.replace(/\u00a0/g, '').trim()) paragraph.remove();
      });
    }

    if (!headings.length) {
      if (aside) aside.hidden = true;
      if (mobileToc) mobileToc.hidden = true;
      if (body) body.classList.add('phq-policy__body--no-toc');
      return;
    }

    if (!primaryHeadings.length) root.classList.add('phq-policy--secondary-headings');

    const usedIds = new Set();
    const formatNavigationLabel = (text) => {
      const letters = text.replace(/[^a-z]/gi, '');
      if (!letters || letters !== letters.toUpperCase()) return text;
      return text
        .toLowerCase()
        .replace(/(^|[.!?]\s+)([a-z])/g, (match, prefix, letter) => `${prefix}${letter.toUpperCase()}`);
    };
    const makeId = (text, index) => {
      const base = text
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 64) || `section-${index + 1}`;
      let id = base;
      let suffix = 2;
      while (usedIds.has(id) || document.getElementById(id)) {
        id = `${base}-${suffix}`;
        suffix += 1;
      }
      usedIds.add(id);
      return id;
    };

    headings.forEach((heading, index) => {
      const label = heading.textContent.trim();
      if (!label) return;
      if (!heading.id) heading.id = makeId(label, index);
      heading.setAttribute('tabindex', '-1');

      [desktopNav, mobileNav].forEach((nav) => {
        if (!nav) return;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = formatNavigationLabel(label);
        nav.appendChild(link);
      });
    });
  };

  const initialisePolicies = () => {
    document.querySelectorAll('[data-policy-section]').forEach(initialisePolicy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialisePolicies, { once: true });
  } else {
    initialisePolicies();
  }
})();

